export default __webpack_public_path__ + "static/media/alternative-solar-bg2.32fb944c.jpeg";